import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React, { useState, useEffect } from "react";
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import apis from "../../../context/api";

// eslint-disable-next-line react/prop-types
function ProductEdit({ id, onSuccess, onCancel }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [productData, setProductData] = useState({
    id: null,
    productName: "",
    productDescription: "",
    allowEditProductDescription: false,
    size: "",
    partNo: "",
    buyPrice: "",
    sellingPrice: 1,
    lowestSellPrice: 1,
    gst: 0,
    minStockQty: 1,
    totalQuantity: 1,
    discount: 0,
    productShortName: "",
  });
  const validateFields = () => {
    const newErrors = {};
    if (!productData.productName.trim()) newErrors.productName = "Name is required";
    if (!productData.sellingPrice) newErrors.sellingPrice = "Selling Price is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // returns true if no errors
  };
  useEffect(() => {
    if (!id) return;
    apis
      .getProductById(id)
      .then((data) => {
        setProductData(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [id, onSuccess]);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;

    if ((name === "minStockQty" || name === "totalQuantity") && Number(value) < 1) {
      newValue = "1";
    }

    setProductData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };
  const updateProduct = () => {
    apis
      .updateProductById(id, productData)
      .then((data) => {
        setLoading(false);
        if (onSuccess) {
          onSuccess(productData);
        }
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };
  const createProduct = () => {
    productData.productShortName = productData.productName;
    apis
      .createProduct(productData)
      .then((data) => {
        setLoading(false);
        if (onSuccess) {
          onSuccess(productData);
        }
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateFields()) return;
    if (id) {
      updateProduct();
    } else {
      createProduct();
    }
  };
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };
  return (
    <MDBox pt={6} pb={6}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox p={5}>
              <Grid container spacing={2}>
                {/*<Grid item xs={12} sm={6} md={6}>
                   <MDInput
                    fullWidth
                    label="Product Short Code"
                    name="productShortName"
                    variant="outlined"
                    value={productData.productShortName}
                    onChange={handleChange}
                    error={!!errors.productShortName}
                    helperText={errors.productShortName}
                    FormHelperTextProps={{
                      sx: { color: "red" },
                    }}
                  />
                </Grid> */}
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Product Name"
                    name="productName"
                    variant="outlined"
                    value={productData.productName}
                    onChange={handleChange}
                    error={!!errors.productName}
                    helperText={errors.productName}
                    FormHelperTextProps={{
                      sx: { color: "red" },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Product Description"
                    name="productDescription"
                    variant="outlined"
                    value={productData.productDescription}
                    onChange={handleChange}
                    error={!!errors.productDescription}
                    helperText={errors.productDescription}
                    FormHelperTextProps={{
                      sx: { color: "red" },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <MDBox display="flex" alignItems="center">
                    <Checkbox
                      name="allowEditProductDescription"
                      checked={productData.allowEditProductDescription}
                      onChange={handleChange}
                    />
                    <MDTypography variant="body2">
                      Allow users to edit description when creating quotations
                    </MDTypography>
                  </MDBox>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Size"
                    name="size"
                    variant="outlined"
                    value={productData.size}
                    onChange={handleChange}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Part No"
                    name="partNo"
                    variant="outlined"
                    value={productData.partNo}
                    onChange={handleChange}
                  />
                </Grid> */}
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Buy Price"
                    name="buyPrice"
                    type="number"
                    variant="outlined"
                    value={productData.buyPrice}
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    fullWidth
                    label="Min Quantity"
                    name="minStockQty"
                    type="number"
                    variant="outlined"
                    value={productData.minStockQty}
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Total Quantity"
                    name="totalQuantity"
                    type="number"
                    variant="outlined"
                    value={productData.totalQuantity}
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Sales Price"
                    name="sellingPrice"
                    type="number"
                    variant="outlined"
                    value={productData.sellingPrice}
                    onChange={handleChange}
                    error={!!errors.sellingPrice}
                    helperText={errors.sellingPrice}
                    FormHelperTextProps={{
                      sx: { color: "red" },
                    }}
                    inputProps={{ min: 0 }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Min Sale Price"
                    name="lowestSellPrice"
                    type="number"
                    variant="outlined"
                    value={productData.lowestSellPrice}
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Discount"
                    name="discount"
                    type="number"
                    variant="outlined"
                    value={productData.discount}
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="GST"
                    name="gst"
                    type="number"
                    variant="outlined"
                    value={productData.gst}
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                pt={4}
                spacing={1}
                display="flex"
                flexWrap="nowrap"
              >
                <Grid item pl={2} pr={2} xs="auto">
                  <MDButton variant="gradient" color="warning" onClick={handleCancel}>
                    Cancel
                  </MDButton>
                </Grid>
                <Grid item xs="auto">
                  <MDButton variant="gradient" color="info" onClick={handleSubmit}>
                    Submit
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default ProductEdit;
